import { apis } from '../../services/api';
import { MediaAudio } from '../../services/Audio';
import { playUnreadMessagesQueue, stopUnreadPlayback } from '../../services/MessagePlayback';
import globalState from '../index';
import moment from 'moment';
import Vue from 'vue';

let messagesApi = apis.mensajesApi;

/** Misma clave numérica para viaje_id venga como string (ruta) o number (API). */
function normalizeTripId (id) {
    if (id === null || id === undefined || id === '') {
        return null;
    }
    const n = Number(id);
    return Number.isNaN(n) ? id : n;
}

/** Cuerpo de index puede ser array puro o envuelto (según proxy/Laravel). */
function normalizeIndexResponse (raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (raw && Array.isArray(raw.data)) {
        return raw.data;
    }
    if (raw && Array.isArray(raw.mensajes)) {
        return raw.mensajes;
    }
    return null;
}

function getCurrentChat (state) {
    if (!state.conversations || !state.conversations.length || state.currentConversation == null) {
        return null;
    }
    const cid = normalizeTripId(state.currentConversation);
    return state.conversations.find(c => normalizeTripId(c.id) === cid) || null;
}

function sortMessagesChronologically (messages) {
    return messages.slice().sort((a, b) => {
        if (a.created_at < b.created_at) return -1;
        if (a.created_at > b.created_at) return 1;
        return 0;
    });
}

const initialState = {
    conversations: [],
    currentConversation: null,
    unreadPlaybackActive: false
};

const state = Object.assign({}, initialState);

// getters
const getters = {
    chats: state => {
        if (state.conversations && state.conversations.length && state.currentConversation != null) {
            console.log('chat getter', state.currentConversation);
            const cid = normalizeTripId(state.currentConversation);
            let chat = state.conversations.find(c => normalizeTripId(c.id) === cid);
            if (chat) {
                let messages = chat.messages.slice();
                messages.sort((a, b) => {
                    if (a.created_at < b.created_at) return -1;
                    if (a.created_at > b.created_at) return 1;
                    return 0;
                });
                return messages;
            } else {
                return [];
            }
        }
        return [];
    },
    unreadedMessagesCount (state, getters) {
        const list = getters.unreadMessagesFromOthers;
        return list ? list.length : 0;
    },
    unreadMessagesFromOthers (state) {
        const chat = getCurrentChat(state);
        const me = globalState.getters['auth/user'];
        if (!chat || !chat.messages || !chat.messages.length || !me) {
            return [];
        }
        const unread = chat.messages.filter(m => m.usuario_id !== me.id && !m.visto);
        return sortMessagesChronologically(unread);
    },
    lastAudioMessage (state, getters) {
        const unread = getters.unreadMessagesFromOthers;
        if (!unread.length) {
            return null;
        }
        for (let i = unread.length - 1; i >= 0; i--) {
            if (unread[i].type === 1) {
                return unread[i];
            }
        }
        return null;
    },
    hasUnreadTextMessages (state, getters) {
        const unread = getters.unreadMessagesFromOthers;
        return unread.some(m => m.type === 0 && m.mensaje);
    },
    canPlayUnreadMessages (state, getters) {
        const unread = getters.unreadMessagesFromOthers;
        if (!unread.length) {
            return false;
        }
        return unread.some(m => {
            if (m.type === 0) {
                return !!(m.mensaje && String(m.mensaje).trim());
            }
            return m.type === 1 && m.audio;
        });
    },
    unreadPlaybackActive: state => state.unreadPlaybackActive
};

// actions

function getMessages ({ state, commit }, params) {
    console.log('getMessages action', params);
    const chatId = normalizeTripId(params.chatId);
    if (chatId == null) {
        return;
    }
    commit('SET_CURRENT_CONVERSATION', chatId);
    let data = { viaje_id: chatId };
    if (params.lastId) {
        data.visto = params.lastId;
    }
    messagesApi.index(data).then((results) => {
        const active = normalizeTripId(state.currentConversation);
        if (active != null && chatId != null && active !== chatId) {
            return;
        }
        const list = normalizeIndexResponse(results);
        if (!list) {
            return;
        }
        commit('SET_MESSAGES', { messages: list, viajeId: chatId });
    });
}

function sendMessage (store, message) {
    if (message.isAudio) {
        // TODO: Implementar enviar audios
    } else {
        const tempId = Date.now();
        message.tempId = tempId;
        store.commit('SET_MESSAGE', message);
        messagesApi.send(message).then((m) => {
            m.tempId = tempId;
            store.commit('UPDATE_MESSAGE', m);
        }).catch((err) => {
            console.error('sendMessage failed', err);
            store.commit('REMOVE_PENDING_MESSAGE', { viaje_id: message.viaje_id, tempId });
        });
    }
}

function endChat (store, conversationId) {
    console.log('end chat');
    store.commit('SET_CURRENT_CONVERSATION', null);
}

let audio = null;
function startRecord (store, { viajeId }) {
    audio = new MediaAudio({ viajeId });
    return audio.startRecord().catch((e) => {
        audio.cancelRecord();
        console.log('ERROR', e);
    });
}

function stopRecord (store, { viajeId }) {
    if (audio) {
        audio.stopRecord().then(() => {
            console.log('audio recorded', audio);
            window.globalAudio = audio;
            let me = globalState.getters['auth/user'];
            let data = {
                isAudio: false,
                type: 1,
                mensaje: null,
                viaje_id: viajeId,
                usuario_id: me.id,
                created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                audio: audio,
                tempId: new Date().getTime()
            };
            return audio.upload().then((m) => {
                store.commit('SET_MESSAGE', data);
                console.log('audio upload success', m);
                if (m) {
                    m.audio = data.audio;
                    m.tempId = data.tempId;
                }
                store.commit('UPDATE_MESSAGE', m);
            }).catch((e) => {
                audio.cancelRecord();
                console.log('ERROR', e);
            });
        });
    }
}

function cancelRecord (store) {
    if (audio) {
        audio.cancelRecord();
    }
}

function pauseAll ({ state }) {
    if (state.conversations && state.conversations.length && state.currentConversation != null) {
        const cid = normalizeTripId(state.currentConversation);
        let chat = state.conversations.find(c => normalizeTripId(c.id) === cid);
        if (!chat || !chat.messages) {
            return;
        }
        chat.messages.forEach(m => {
            if (m.audio && m.audio.playing) {
                m.audio.pause();
            }
        });
    }
}

function markAsRead (store) {
    console.log('MARK_AS_READ_IN_CONVERSATION', store.state.currentConversation);
    store.commit('MARK_AS_READ_IN_CONVERSATION', store.state.currentConversation);
}

function playUnreadMessages ({ state, commit, dispatch }) {
    if (state.unreadPlaybackActive) {
        return dispatch('stopUnreadPlayback');
    }
    const messages = globalState.getters['messages/unreadMessagesFromOthers'];
    if (!messages.length) {
        return Promise.resolve();
    }
    commit('SET_UNREAD_PLAYBACK_ACTIVE', true);
    const pauseAllFn = () => dispatch('pauseAll');
    return playUnreadMessagesQueue(messages, { pauseAll: pauseAllFn }).then((completed) => {
        commit('SET_UNREAD_PLAYBACK_ACTIVE', false);
        if (completed) {
            dispatch('markAsRead');
        }
    }).catch((err) => {
        console.error('playUnreadMessages failed', err);
        commit('SET_UNREAD_PLAYBACK_ACTIVE', false);
    });
}

function stopUnreadPlaybackAction ({ commit, dispatch }) {
    stopUnreadPlayback(() => dispatch('pauseAll'));
    commit('SET_UNREAD_PLAYBACK_ACTIVE', false);
}

const actions = {
    getMessages,
    sendMessage,
    endChat,
    startRecord,
    stopRecord,
    cancelRecord,
    pauseAll,
    markAsRead,
    playUnreadMessages,
    stopUnreadPlayback: stopUnreadPlaybackAction
};

// mutations
const mutations = {
    SET_CURRENT_CONVERSATION (state, id) {
        state.currentConversation = id === null || id === undefined ? null : normalizeTripId(id);
    },
    SET_MESSAGES (state, payload) {
        if (!state.conversations) {
            state.conversations = [];
        }
        let messages;
        let fallbackViajeId = null;
        if (Array.isArray(payload)) {
            messages = payload;
        } else if (payload && Array.isArray(payload.messages)) {
            messages = payload.messages;
            fallbackViajeId = normalizeTripId(payload.viajeId);
        } else {
            return;
        }
        messages.forEach(message => {
            const normalizedViajeId = normalizeTripId(message.viaje_id);
            const vid = normalizedViajeId != null ? normalizedViajeId : fallbackViajeId;
            if (vid == null) {
                return;
            }
            if (message.viaje_id == null && fallbackViajeId != null) {
                Vue.set(message, 'viaje_id', fallbackViajeId);
            }
            let conversation = state.conversations.find(c => normalizeTripId(c.id) === vid);

            if (!conversation) {
                conversation = {
                    id: vid,
                    messages: []
                };
                if (message.type === 1) { // Audio
                    let _audio = new MediaAudio({ id: message.id, checksum: message.checksum, viajeId: message.viaje_id });
                    Vue.set(message, 'audio', _audio);
                }
                state.conversations.push(conversation);
                conversation.messages.push(message);
            } else {
                let m = conversation.messages.find(m => m.id === message.id);
                if (m) {
                    if (m.visto) {
                        message.visto = true;
                    }
                    m = Object.assign(m, message); // Eso no se si está del todo correcto
                } else {
                    if (message.id != null) {
                        conversation.messages = conversation.messages.filter((existing) => {
                            if (existing.id) {
                                return true;
                            }
                            if (normalizeTripId(existing.viaje_id) !== vid || existing.usuario_id !== message.usuario_id || existing.type !== message.type) {
                                return true;
                            }
                            if (message.type === 0 && existing.mensaje !== message.mensaje) {
                                return true;
                            }
                            return false;
                        });
                    }
                    if (message.type === 1) { // Audio
                        let _audio = new MediaAudio({ id: message.id, checksum: message.checksum, viajeId: message.viaje_id });
                        Vue.set(message, 'audio', _audio);
                    }
                    conversation.messages.push(message);
                }
            }
        });
        if (fallbackViajeId != null && state.currentConversation == null) {
            state.currentConversation = fallbackViajeId;
        }
    },
    REMOVE_MESSAGES (state, conversationId) {
        if (state.conversations && state.conversations.length) {
            const cid = normalizeTripId(conversationId);
            let index = state.conversations.findIndex(c => normalizeTripId(c.id) === cid);
            if (index !== -1) {
                state.conversations.splice(index, 1);
            }
        }
    },
    UPDATE_MESSAGE (state, message) {
        if (state.conversations && state.conversations.length) {
            const vid = normalizeTripId(message.viaje_id);
            let conversation = state.conversations.find(c => normalizeTripId(c.id) === vid);
            if (conversation) {
                let m = conversation.messages.find(m => m.tempId === message.tempId);
                if (m) {
                    m = Object.assign(m, message); // Eso no se si está del todo correcto
                }
            }
        }
    },
    REMOVE_PENDING_MESSAGE (state, { viaje_id, tempId }) {
        if (!state.conversations || !state.conversations.length) {
            return;
        }
        const vid = normalizeTripId(viaje_id);
        const conversation = state.conversations.find(c => normalizeTripId(c.id) === vid);
        if (!conversation) {
            return;
        }
        const idx = conversation.messages.findIndex(m => m.tempId === tempId && (m.id == null));
        if (idx !== -1) {
            conversation.messages.splice(idx, 1);
        }
    },
    SET_MESSAGE (state, message) {
        if (!state.conversations) {
            state.conversations = [];
        }
        const vid = normalizeTripId(message.viaje_id);
        if (vid == null) {
            return;
        }
        let conversation = state.conversations.find(c => normalizeTripId(c.id) === vid);
        if (!conversation) {
            conversation = {
                id: vid,
                messages: []
            };
            state.conversations.push(conversation);
        }
        if (message.type === 1 && !message.audio) {
            let _audio = new MediaAudio({ id: message.id, checksum: message.checksum, viajeId: message.viaje_id });
            Vue.set(message, 'audio', _audio);
        }
        conversation.messages.push(message);
    },
    MARK_AS_READ_IN_CONVERSATION (state, conversationId) {
        if (state.conversations && state.conversations.length) {
            const cid = normalizeTripId(conversationId);
            let conversation = state.conversations.find(c => normalizeTripId(c.id) === cid);
            if (conversation) {
                conversation.messages.forEach(m => {
                    // m.visto = true;
                    Vue.set(m, 'visto', true);
                });
            }
        }
    },
    SET_UNREAD_PLAYBACK_ACTIVE (state, active) {
        state.unreadPlaybackActive = !!active;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/messages.js